"use client";

import Link from "next/link";
import Image from "next/image";
import styles from "./LandingFooter.module.css";

export default function LandingFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerGrid}>
          <div className={styles.footerBrand}>
            <Link href="/" className={styles.logoLink}>
              <Image
                src="https://assets.flare.link/logoFlare.png"
                alt="Flare"
                width={80}
                height={18}
                quality={100}
              />
            </Link>
            <p className={styles.brandDescription}>
              Beautiful screen recording for creators.
            </p>
          </div>

          <div className={styles.footerColumn}>
            <h4 className={styles.columnTitle}>Product</h4>
            <nav className={styles.columnNav}>
              <Link href="/download" className={styles.footerLink}>
                Download
              </Link>
              <a href="/#pricing" className={styles.footerLink}>
                Pricing
              </a>
            </nav>
          </div>

          <div className={styles.footerColumn}>
            <h4 className={styles.columnTitle}>Resources</h4>
            <nav className={styles.columnNav}>
              <Link href="/help" className={styles.footerLink}>
                Documentation
              </Link>
            </nav>
          </div>

          <div className={styles.footerColumn}>
            <h4 className={styles.columnTitle}>Legal</h4>
            <nav className={styles.columnNav}>
              <Link href="/privacy" className={styles.footerLink}>
                Privacy Policy
              </Link>
              <Link href="/terms" className={styles.footerLink}>
                Terms &amp; Conditions
              </Link>
              <Link href="/cookies" className={styles.footerLink}>
                Cookie Policy
              </Link>
              <Link href="/dpa" className={styles.footerLink}>
                Data Processing Addendum
              </Link>
              <Link href="/licenses" className={styles.footerLink}>
                Licenses
              </Link>
              <Link href="/sitemap" className={styles.footerLink}>
                Sitemap
              </Link>
            </nav>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p className={styles.copyright}>© 2026 Flare. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
